<!-- Edit toolbar — two centered rows (Row 1: tools · Row 2: style + actions). -->
<div class="atb" role="toolbar" aria-label="Annotation tools">

  <!-- Row 1 — drawing tools -->
  <div class="atb__row">
    <div class="atb__group">
      <button type="button" class="atb__tool" *ngFor="let t of tools"
              [class.is-active]="activeTool === t.id"
              (click)="toolChange.emit(t.id)"
              [matTooltip]="t.label + (t.key ? ' (' + t.key + ')' : '')" matTooltipPosition="below">
        <mat-icon>{{ t.icon }}</mat-icon>
      </button>
    </div>
  </div>

  <!-- Row 2 — color / stroke / opacity · undo / redo / delete -->
  <div class="atb__row">
    <!-- Color palette -->
    <div class="atb__colors">
      <button type="button" class="atb__swatch" *ngFor="let c of colors"
              [class.is-active]="selectedColor === c"
              [style.background]="c" (click)="colorChange.emit(c)"
              [matTooltip]="c" matTooltipPosition="below"></button>
    </div>

    <span class="atb__divider"></span>

    <!-- Stroke width -->
    <div class="atb__strokes">
      <button type="button" class="atb__stroke" *ngFor="let w of strokeWidths"
              [class.is-active]="strokeWidth === w" (click)="strokeChange.emit(w)"
              [matTooltip]="w + 'px'" matTooltipPosition="below">
        <span class="atb__stroke-dot" [style.width.px]="dotSize(w)" [style.height.px]="dotSize(w)"></span>
      </button>
    </div>

    <span class="atb__divider"></span>

    <!-- Opacity -->
    <div class="atb__opacity" matTooltip="Opacity" matTooltipPosition="below">
      <mat-icon>opacity</mat-icon>
      <input type="range" min="0.1" max="1" step="0.1" [value]="opacity"
             (input)="opacityChange.emit(+$any($event.target).value)">
    </div>

    <span class="atb__divider"></span>

    <!-- Undo / redo / delete -->
    <button type="button" class="atb__action" [disabled]="!canUndo" (click)="undo.emit()"
            matTooltip="Undo (Ctrl+Z)" matTooltipPosition="below"><mat-icon>undo</mat-icon></button>
    <button type="button" class="atb__action" [disabled]="!canRedo" (click)="redo.emit()"
            matTooltip="Redo (Ctrl+Y)" matTooltipPosition="below"><mat-icon>redo</mat-icon></button>
    <button type="button" class="atb__action atb__action--danger" [disabled]="!hasSelection" (click)="deleteSelected.emit()"
            matTooltip="Delete selected (Del)" matTooltipPosition="below"><mat-icon>delete</mat-icon></button>
  </div>
</div>
